module.exports = __webpack_public_path__ + "static/img/vivian7.e7a67f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/employeeStories/vivian7.jpg
// module id = hS70
// module chunks = 1